import React from "react";
import { NavLink } from "react-router-dom";

const logos = [
  { image: require("./../../images/client-logo/logo1.jpg") },
  { image: require("./../../images/client-logo/logo2.jpg") },
  { image: require("./../../images/client-logo/logo3.jpg") },
  { image: require("./../../images/client-logo/logo4.jpg") },
];

var bgimg1 = require("./../../images/background/bg-12.jpg");
var bgimg2 = require("./../../images/background/cross-line2.png");

class ClientsLogo1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full  mobile-page-padding bg-white  p-t20  bg-repeat"
          //  style={{ backgroundImage: 'url(' + bgimg1 + ')' }}
        >
          <div className="container">
            {/* TITLE START */}
            <div  data-aos-duration="800"  data-aos="fade-up" className="section-head">
              <div className="sx-separator-outer separator-center">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  //   style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                >
                  <h3 className="sep-line-one">Nos Valeurs</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            <div className="section-content">
              <div className="client-grid m-b40">
                <div className="row justify-content-center">
                  {logos.map((item, index) => (
                    <div
                      className="col-lg-3 col-md-4 col-sm-6 col-6 m-b30"
                      key={index}
                     
                    >
                      <div className="client-logo-pic">
                        <img  data-aos-duration="800"  data-aos="zoom-in" src={item.image} alt="" />
                        {/* <div>
                          <span>Voir Plus</span>
                        </div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>Valeurs</strong>
          </div> */}
        </div>
      </>
    );
  }
}

export default ClientsLogo1;
